import { Filter } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { DatePickerWithPresets } from "@/shared/components/range-picker/RangePicker";
import { DynamicSelectFilter } from "@/shared/components/filters/Filters";
import type { SystemDictionary } from "@/shared/api/filters";
import { useState, type Dispatch, type SetStateAction } from "react";
import type { NotificationsFiltersState } from "../../pages/NotificationsPage";
import { Input } from "@/shared/components/ui/input";

interface NotificationsFiltersProps {
  totalCount: number;
  filteredCount: number;
  setFilters: Dispatch<SetStateAction<NotificationsFiltersState>>;
  filters: NotificationsFiltersState;
}

const NOTIFICATION_STATUSES = [
  { value: "partial", label: "Частично" },
  { value: "delivered", label: "Доставлено" },
  { value: "failed", label: "Ошибка" },
];

export function NotificationsFilters({
  totalCount,
  filteredCount,
  setFilters,
  filters,
}: NotificationsFiltersProps) {
  // Функция для обновления конкретного фильтра
  const updateStatus = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      status: value === "all" ? "" : value,
    }));
  };

  const updateFilter = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value === "all" ? "" : value }));
  };

  const handleDateChange = (dateFrom: string, dateTo: string) => {
    setFilters((prev) => ({ ...prev, dateFrom, dateTo, page: 1 }));
  };

  const resetFilters = () => {
    setFilters({
      status: "",
      page: 1,
      pageSize: 20,
      dateFrom: "",
      dateTo: "",
      search: "",
    });
  };

  return (
    <div className="bg-white rounded-t-lg border p-4">
      <div className="flex flex-wrap items-center gap-3">
        <Filter className="w-5 h-5 text-gray-500" />

        <Input
          placeholder="Поиск заголовку или сообщению"
          value={filters.search}
          onChange={(e) => updateFilter("search", e.target.value)}
          className="h-10 w-[280px]"
        />

        <DatePickerWithPresets
          dateFrom={filters.dateFrom}
          dateTo={filters.dateTo}
          onChange={handleDateChange}
        />

        <DynamicSelectFilter
          placeholder="Статус"
          data={NOTIFICATION_STATUSES}
          value={filters.status || undefined}
          onChange={updateStatus}
          valueExtractor={(item) => item.value}
          labelExtractor={(item) => item.label}
        />

        <Button
          variant="ghost"
          size="sm"
          className="h-10"
          onClick={resetFilters}
        >
          Сброс фильтров
        </Button>
        <span className="text-sm text-gray-600 ml-auto">
          Показано {filteredCount} из {totalCount}
        </span>
      </div>
    </div>
  );
}
